module.exports = __webpack_public_path__ + "img/enterprise.84aff555.png";